import Vue from 'vue'
import request from '../request'
// 获取省份列表
export function getProvinceList (data) {
    return request({
        url: Vue.prototype.baseURL + '/services/fs-region/selectList',
        method: 'POST',
        data
    })
}


//面积产量历史数据表格
export function getHistoryTableData (data) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/s-area-yield/selectListByPage',
        method: 'POST',
        data
    })
}

//面积产量预测数据图表
export function getTargetChartData (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/s-area-yield/forecast',
        method: 'GET',
        params
    })
}

// 本地 生产模型 预测接口
export function localForecastModel (params) {
    return request({
        url: Vue.prototype.baseURL + '/model/model-application/productModel',
        method: 'POST',
        params
    })
}

// 文件上传
export function uploadFile (data) {
    return request({
        url: Vue.prototype.baseURL + '/brand/file/upload?folder=localForecastModel',
        method: 'POST',
        data
    })
}





